import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// helpers
import get from 'lodash.get';
import classnames from 'classnames';

// styles
import styles from './SbSharedTitle.scss';

// constants
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
const { SEARCH, DESIGN } = pageTypes;

const SbSharedTitleComponent = ({
    itemSearch,
    searchTerm,
    customSearchHeader,
    Heading,
    showFollowButton,
    showContentModule,
    children,
}) => {
    const header = get(itemSearch, 'meta.header');
    const subHeader = get(itemSearch, 'meta.subHeader');
    const pageType = get(itemSearch, 'pageType');
    const subHeaderStyles = classnames(styles.subHeader, {
        [styles.withFollowButton]: showFollowButton,
    });

    const HeadingTag = pageType === DESIGN && showContentModule ? 'h2' : 'h1';

    const headerTitle =
        pageType === SEARCH ? (
            <span>
                {customSearchHeader || header}{' '}
                <i className={styles.searchTerm} data-tn="search-term">
                    "{searchTerm}"
                </i>
            </span>
        ) : (
            header
        );

    return (
        <div className={styles.container}>
            <div className={styles.headerWrapper}>
                <HeadingTag className={styles.header} data-tn="header-title">
                    {headerTitle}
                </HeadingTag>
                {showFollowButton && children}
            </div>
            {subHeader && (
                <Heading className={subHeaderStyles} data-tn="header-sub-title">
                    {subHeader}
                </Heading>
            )}
        </div>
    );
};

SbSharedTitleComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    searchTerm: PropTypes.string,
    customSearchHeader: PropTypes.node,
    Heading: PropTypes.object,
    showFollowButton: PropTypes.bool,
    showContentModule: PropTypes.bool,
    children: PropTypes.node,
};

SbSharedTitleComponent.defaultProps = {
    showContentModule: false,
};
export const SbSharedTitle = createFragmentContainer(SbSharedTitleComponent, {
    itemSearch: graphql`
        fragment SbSharedTitle_itemSearch on ItemSearchQueryConnection {
            pageType
            meta {
                header
                subHeader
            }
        }
    `,
});
